import * as React from "react";
import Skeleton from "react-loading-skeleton";
import { DISTANCE_CONFIRMATION_TXT } from "../../Shared/AppMessages";
import axios from "axios";
import { Dialog } from "@progress/kendo-react-dialogs";
import MapModal from "./MapModal";
import { GOOGLE_MAP_PARAMETER, LocalizationResource, SETTINGS, SettingCategory } from "../../Shared/AppConstants";
import { clientSettingsData, errorToastr } from "../../../HelperMethods";
import { ErrorComponent } from "../../ReusableComponents";
import auth from "../../Auth";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { AppPermissions } from "../../Shared/Constants/AppPermissions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faThumbsDown } from "@fortawesome/free-solid-svg-icons";
import { LocalizationHelper } from "../../../Localization/helpers/LocalizationHelper";

export interface CandidateDistanceProps {
    locationId?: string;
    providerAddress?: any;
    distanceFromLocation?: any;
    handleAlert?: any;
    isOverride?: any;
    handleChangeApproval?: any;
}

export interface CandidateDistanceState {
    locationAddress?: any;
    distance?: any;
    selectedMode: any;
    showMapModal: boolean;
    result?: any;
    error?: any;
    maxDistance?: any;
    showError: boolean;
    isAgree: boolean;
    clientId?: string;
    showLoader: boolean;
}

const script = document.createElement('script');

class CandidateDistance extends React.Component<CandidateDistanceProps, CandidateDistanceState> {
    mapRef: React.RefObject<HTMLDivElement>;
    directionsService: google.maps.DirectionsService | null;
    directionsRenderer: google.maps.DirectionsRenderer | null;

    constructor(props: CandidateDistanceProps) {
        super(props);
        this.state = {
            showMapModal: false,
            showError: false,
            selectedMode: 'DRIVING' as google.maps.TravelMode,
            isAgree: false,
            clientId: auth.getClient(),
            showLoader: true
        };
    }

    componentDidMount() {
        this.getGoogleAPIKey();
        
        if (this.state.clientId){
            this.getClientSettings(this.state.clientId);
        }

        if (this.props.distanceFromLocation){
            this.setState({distance: this.props.distanceFromLocation});
        }
    }

    handleScriptLoad = () => {
        this.directionsService = new window.google.maps.DirectionsService();

        if (this.props.locationId){
            this.getLocationData(this.props.locationId)
        }
    }

    getGoogleAPIKey = () => {

        axios
          .get(`api/grid/googlemapkey/${GOOGLE_MAP_PARAMETER}`)
          .then((res:any) => {
              if (res.data){
                const { data } = res;
                this.loadGoogleScript(data);
              }
          })
      }
    
      loadGoogleScript = (data) => {
        let existingScript = document.getElementById("googleMapsId");
    
        if (!existingScript){
          script.src = `https://maps.googleapis.com/maps/api/js?key=${data}&libraries=places`;
          script.async = true;
          script.defer = true;
          script.id = "googleMapsId"
          script.onload = () => this.handleScriptLoad();
          document.body.appendChild(script);
        }else{
          this.handleScriptLoad();
        }
      }

    getClientSettings = (clientId) => {
        clientSettingsData(clientId, SettingCategory.CANDIDATE, SETTINGS.DISTANCE_FOR_SITE_LOCATION, (response) => {
          this.setState({ maxDistance : response != "" ? Number(response) : response });
        });
    };

    getLocationData = (locationId?) => {
        axios.get(`api/clients/location/detail/${locationId}`).then((res:any) => {
            const { data } = res;
            this.setState({
                locationAddress: this.createAddress(data)
            }, () => {
                this.calculateDistance()
                this.setState({showLoader: false});
            })
        });
    }

    createAddress = (data:any) => {
        let address = "";
        if (data.address1 != null && data.address1?.trim() != ""){
            address += `${data.address1}, `
        }
        if (data.address2 != null && data.address2?.trim() != ""){
            address += `${data.address2}, `
        }
        if (data.city != null){
            address += `${data.city}, `
        }
        if (data.state != null){
            address += `${data.state}, `
        }
        if (data.pinCodeId != null){
            address += `${data.pinCodeId}`
        }

        return address;
    }

    calculateDistance = () => {
        const { providerAddress } = this.props;
        const { locationAddress, selectedMode } = this.state;
        if (providerAddress == "" || locationAddress == "" || providerAddress == undefined || locationAddress == undefined){
          errorToastr("Provider or "+LocalizationHelper.getLocalizedTitle(LocalizationResource.Location_Label, "Location") +" Address can not be blank.");
          return false;
        }

        if (providerAddress != "" && locationAddress != "") {
          
          if (this.directionsService) {
            const request = {
              origin: providerAddress,
              destination: locationAddress,
              travelMode: selectedMode,
            };
    
            this.directionsService.route(request, (result: any, status: any) => {
              if (status === window.google.maps.DirectionsStatus.OK) {
                let distance = result.routes[0].legs[0].distance.text?.split(' ')[0]?.trim();

                this.setState({ distance, result });
              } 
              else {
                if (this.directionsRenderer) {
                    const emptyDirectionsResult: google.maps.DirectionsResult = {
                        geocoded_waypoints: [],
                        routes: [],
                      };
                      this.directionsRenderer.setDirections(emptyDirectionsResult);
                }
                errorToastr("It Only Calculate Distance By Road");
              }
            });
          }
        }
      };

    validateDistance = (isOverride?, targetDateError?, showError?, billRateValidate?) => {
        const { distance, maxDistance, isAgree } = this.state;
        let showDistanceError = (maxDistance != "" &&
                          maxDistance != undefined &&
                          distance != undefined) &&
                          (isAgree == true)
                          ? false : true;

        let distanceDetails = { ...this.state };

        if (isAgree && (maxDistance < 1 || maxDistance == "")){
            showDistanceError = false;
            return { showDistanceError, distanceDetails };
        }
        
        if (!billRateValidate && !targetDateError && !showError && !showDistanceError &&
            maxDistance != "" && maxDistance != undefined && distance != undefined &&
            Number(distance.replaceAll(',', '')) < maxDistance){
            if (this.props.handleAlert ){
                this.props.handleAlert()
            }

            if (!isOverride){
                showDistanceError = true;
            }
        }

        this.setState({ showError: showDistanceError});

        return { showDistanceError, distanceDetails };

    }

    getDistance = () => {
        let distanceDetails = { ...this.state };
        return { distanceDetails };
    }

    handleChange = (e, modelProp) => {
        var stateObj = {};
        stateObj[modelProp] =  e.target.type == "checkbox" ? e.target.checked : e.target.value;
        this.setState(stateObj);
    }

    render() {
        const { providerAddress } = this.props;
        const { showLoader, locationAddress, distance, selectedMode, showError, isAgree } = this.state;

        return (
            <div className="">
                <div className="row">
                    <div className="col-12 pl-0 pr-0">
                        {showLoader &&
                            Array.from({ length: 1 }).map((item, i) => (
                                <div className="row mx-auto mt-2" key={i}>
                                    {Array.from({ length: 3 }).map((item, j) => (
                                        <div className="col-12 col-sm-4 col-lg-4 mt-sm-0  mt-1" key={j}>
                                            <Skeleton width={100} />
                                            <Skeleton height={30} />
                                        </div>
                                    ))}
                                </div>
                            ))
                        }
                        {!this.state.showLoader && (
                            <div className="row text-dark">
                                <div className="col-12 col-sm-6 col-lg-4">
                                    <div className="row">
                                    <div className="col-6 text-right">Provider Address:</div>
                                        <div className="col-6 font-weight-bold pl-0 text-left word-break-div">
                                            {providerAddress}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6 col-lg-4">
                                    <div className="row">
                                    <div className="col-6 text-right">{LocalizationHelper.getLocalizedTitle(LocalizationResource.Location_Label, "Location")} Address:</div>
                                        <div className="col-6 font-weight-bold pl-0 text-left word-break-div">
                                            {locationAddress}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-3 col-lg-3">
                                    <div className="row">
                                    <div className="col-6 text-right">Distance (in miles):</div>
                                        <div className="col-5 pl-0 text-left word-break-div">
                                            <NumericTextBox
                                                className="form-control"
                                                placeholder="Distance"
                                                value={distance != undefined && distance != null ? distance : 0}
                                                min={0}
                                                name="distance"
                                                // onChange={(e) => this.handleChange(e, "distance")}
                                                disabled={true}
                                                spinners={false}
                                            />

                                            {showError && (distance == undefined || distance == null || distance == "") && (
                                                <ErrorComponent />
                                            )}
                                            
                                        </div>
                                        <div className="col-1 pl-0 text-left word-break-div">
                                            <span>
                                                <div className="col-auto pr-0 timesheet-doc-portfolio" title="Show Map" onClick={() => this.setState({showMapModal : true})}>
                                                    <span className="k-icon k-i-map-marker shadow"></span>
                                                </div>
                                            </span>
                                        </div>
                                        
                                    </div>
                                </div>
                                
                                {auth.hasPermissionV2(AppPermissions.APPROVE_REJECT_OVERRIDE) &&
                                 this.props.isOverride ?
                                   <div className="col-12 col-sm-12 col-lg-12 text-center mt-3">
                                        <span>
                                            <button
                                                type="button"
                                                className="btn button button-bg mr-2 shadow mb-2 mb-xl-0"
                                                onClick={() => this.props.handleChangeApproval(true, false)}
                                            >
                                                <FontAwesomeIcon
                                                    className={"mr-2"}
                                                    icon={faCheckCircle}
                                                />
                                                Approve
                                            </button>
                                        </span>
                                        
                                        <span>
                                            <button
                                                type="button"
                                                className="btn button button-reject mr-2 shadow mb-2 mb-xl-0"
                                                onClick={() => this.props.handleChangeApproval(false, true)}
                                            >
                                                <FontAwesomeIcon
                                                    className={"mr-2"}
                                                    icon={faThumbsDown}
                                                />
                                                Reject
                                            </button>
                                        </span>
                                    </div>
                                : 
                                    <div className="col-12 mt-2 pl-4">
                                        <label className="container-R d-flex mb-0 pb-3">
                                            <span className="Introduction-line-height ml-1 pl-3">
                                                {DISTANCE_CONFIRMATION_TXT}
                                            </span>
                                            <input
                                                type="checkbox"
                                                onChange={(e) => this.handleChange(e, "isAgree")}
                                                checked={isAgree}
                                            />
                                            <span className="checkmark-R checkPosition checkPositionTop"></span>
                                            
                                        </label>
                                        <div className="pl-3">
                                            {showError && !isAgree && (
                                                <ErrorComponent />
                                            )}
                                        </div>
                                    </div>
                                }

                            </div>
                        )}
                        
                    </div>
                    {this.state.showMapModal && (
                        <div id="add-ClientJobCatalog">
                            <Dialog className="col-12 For-all-responsive-height">
                                <MapModal
                                    providerAddress={providerAddress}
                                    locationAddress={locationAddress}
                                    selectedMode={selectedMode}
                                    onCloseModal={() => this.setState({ showMapModal: false })}
                                    onOpenModal={() => this.setState({ showMapModal: true })}
                                />
                            </Dialog>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default CandidateDistance;